module.exports = __webpack_public_path__ + "img/foto_team.0eabd5ce.jpg";